'use strict';

export default function routes($routeProvider) {
  'ngInject';
  $routeProvider
    .when('/monthly-selling', {
      template: require('./monthlySelling.pug'),
      controller: 'MonthlySellingController',
      controllerAs: 'monthlySelling',
    });
};




// WEBPACK FOOTER //
// ./client/app/manager/monthlySelling/monthlySelling.routes.ts